import React, { useState } from "react";

import styled from "react-emotion";

import { translate } from "react-i18next";

import { Box, Flex, Text } from "src/components";
import { Button } from "src/components/Form";

const Iframe = styled.iframe({
  borderWidth: 0,
  width: "100%",
  flex: 1,
});

const Disclosure = ({ t, onSubmit, loginState }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  return (
    <Flex flex={1} flexDirection="column">
      <Flex mx={-2}>
        <Iframe
          src={loginState.disclosureUrl}
          style={{ height: 450 }}
          onLoad={() => setIframeLoaded(true)}
        />
      </Flex>
      {iframeLoaded ? (
        <Flex mt={2}>
          <Button
            title={t("olb.acceptDisclosureButton", {
              defaultValue: "Accept Disclosure",
            })}
            disabled={submitting}
            onClick={() =>
              onSubmit(
                {
                  accepted: true,
                },
                { setSubmitting }
              )
            }
          />
        </Flex>
      ) : null}
    </Flex>
  );
};

export default translate("translations")(Disclosure);



// WEBPACK FOOTER //
// ./src/banking/authentication/Disclosure.js